export default class PlagiarismPdf {
  private readonly _id: string;
  private readonly _links: object;
  constructor({id, links}) {
    this._id = id;
    this._links = links;
  }

  get id(): string {
    return this._id;
  }

  get links(): object {
    return this._links;
  }
}
